import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const PaymentsRedux = createActions(
  {
    createPaymentRequest: ['id', 'data'],
    createPaymentSuccess: ['response'],
    createPaymentError: ['err'],
  },
  {
    prefix: 'PARENT_PLATFORM_PAYMENTS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = PaymentsRedux
export const PaymentsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  payment: {
    fetching: false,
    result: null,
    error: null,
  },
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const createPaymentRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  payment: {
    fetching: true,
    result: null,
    error: null,
  },
}, d)
const createPaymentSuccess = (state, { response }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  payment: {
    fetching: false,
    result: response,
    error: null,
  },
}, d)

const createPaymentError = (state, { err }) => state.merge({
  sending: {
    fetching: false,
    error: err,
  },
  payment: {
    fetching: false,
    result: null,
    error: err,
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.createPaymentRequest]: createPaymentRequest,
    [Types.createPaymentSuccess]: createPaymentSuccess,
    [Types.createPaymentError]: createPaymentError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/PaymentsRedux.js